import { CreditCard, Headset, UserCircle } from '@phosphor-icons/react'
import { motion } from 'framer-motion'

const FACTS = [
  {
    icon: UserCircle,
    title: 'Una persona, no un bot',
    body: 'Tienes un asesor asignado con nombre y WhatsApp directo. El mismo de principio a fin.',
  },
  {
    icon: CreditCard,
    title: 'Pagos en cuotas',
    body: 'Tarjetas locales en cuotas o abonos parciales antes de salir.',
  },
  {
    icon: Headset,
    title: 'Asistencia durante el viaje',
    body: 'Cambios de vuelo, conexiones perdidas o un hotel que no cumple: lo resolvemos nosotros.',
  },
]

const ease = [0.16, 1, 0.3, 1]

export default function WhyUs() {
  return (
    <section id="nosotros" className="scroll-mt-16 bg-white px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-6 lg:pt-4">
          <h2 className="max-w-xl font-display text-3xl font-extrabold tracking-tight text-navy-950 md:text-5xl">
            Lo que cambia cuando alguien viaja contigo, aunque no vaya.
          </h2>
          <ul className="mt-10 flex flex-col gap-8">
            {FACTS.map((fact, i) => (
              <motion.li
                key={fact.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.55, ease, delay: i * 0.08 }}
                className="flex gap-5"
              >
                <div className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-sunset-50 text-sunset-600">
                  <fact.icon size={24} weight="fill" />
                </div>
                <div>
                  <h3 className="font-display text-xl font-bold text-navy-950">{fact.title}</h3>
                  <p className="mt-1 max-w-[48ch] text-base leading-relaxed text-navy-700/60">{fact.body}</p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease }}
          className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-navy-950 lg:col-span-6 lg:aspect-auto lg:min-h-[560px]"
        >
          <video
            src="/Video/Despega.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 size-full object-cover"
          />
          <div className="absolute inset-0 bg-navy-950/40" />
          <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
            <div className="rounded-2xl border border-white/15 bg-white/10 p-5 backdrop-blur-md">
              <p className="text-sm font-medium leading-relaxed text-white">
                "En Despega creemos que viajar transforma vidas. Por eso hacemos que cada destino, trámite y
                experiencia sea fácil, segura y memorable."
              </p>
              <p className="mt-2 text-xs font-bold text-sunset-400">— Yesenia Santizo, CEO de Despega</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
